<template>
	<button type="button" class="slide-sheet__action" @click="handleClick">
		<span class="slide-sheet__action__name">{{ props.name }}</span>
	</button>
</template>

<script setup lang="ts">
import {useRouter} from '#imports';
import {type SlideSheetActionProps} from "./SlideSheetActionProps";
import {isString} from "@spoferan/spoferan-ts-core";

const props = defineProps<SlideSheetActionProps>();
const emit = defineEmits(['click']);

const router = useRouter();

function handleClick() {
	if (!props.disabled) {
		if (props.callback) {
			props.callback();
		}

		if (props.to) {
			const toPath = isString(props.to) ? (props.to as string) : (props.to as object).path;
			const isAbsolute = toPath.startsWith('http');
			if (isAbsolute) {
				if (props.replace) {
					window.location.replace(toPath);
				} else {
					window.location.href = toPath;
				}
			} else {
				if (props.replace) {
					router.replace(props.to);
				} else {
					router.push(props.to);
				}
			}
		}
		emit('click');
	}
}

</script>

<style>
.slide-sheet__action {
  display: block;
  width: 100%;
  border: none;
  cursor: pointer;
  padding: 14px var(--van-padding-md);
  font-size: var(--van-action-sheet-item-font-size);
  background: var(--van-action-sheet-item-background);
  box-sizing: border-box !important;
}
.slide-sheet__action:active {
  background-color: var(--van-active-color);
}
</style>